var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRPreviousLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn-secondary",
    serifid: "btn secondary"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ph-truck"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ph-desktop"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "ph-note-pencil"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "ph-pen-nib"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-5",
    serifid: "Rating 5"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4-5",
    serifid: "Rating 4,5"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4",
    serifid: "Rating 4"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3-5",
    serifid: "Rating 3,5"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3",
    serifid: "Rating 3"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2-5",
    serifid: "Rating 2,5"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2",
    serifid: "Rating 2"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1-5",
    serifid: "Rating 1,5"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1",
    serifid: "Rating 1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "iconR-previous-left",
    x: 0,
    y: 0,
    width: 30,
    height: 60,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.544,28.385l15.581,-22.253c0.841,-1.2 2.499,-1.493 3.7,-0.652c1.2,0.841 1.493,2.498 0.652,3.699l-14.579,20.821l14.579,20.821c0.841,1.201 0.548,2.858 -0.652,3.699c-1.201,0.841 -2.859,0.548 -3.7,-0.652l-15.581,-22.253c-0.2,-0.262 -0.347,-0.556 -0.438,-0.866l-0.003,-0.01c-0.068,-0.235 -0.102,-0.477 -0.104,-0.718l-0,-0.042c0.002,-0.241 0.036,-0.483 0.104,-0.718l0.003,-0.01c0.091,-0.31 0.238,-0.604 0.438,-0.866Z",
    style: {
      fill: "#808080"
    }
  }), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "chat-left-text"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRPreviousLeft);
export default __webpack_public_path__ + "static/media/iconR-previous-left.b5470de7b30e3952cda80b230de3af77.svg";
export { ForwardRef as ReactComponent };